<div class="component-main-container">
  <!-- container do mapa -->
  <div class="full" id="map" #map></div>
</div>

<button (click)="openDemonstrationMode()" class="btn btn-success view" id="demoMode">
  <mat-icon class="component-svg-icon" svgIcon="bx-play"></mat-icon>
</button>

<!-- Botão para alternar o tema do mapa entre modo claro e modo escuro -->
<button (click)="changeMapTheme()" class="btn btn-success view" id="modeDark">
  <mat-icon class="component-svg-icon" svgIcon="bx-theme"></mat-icon>
</button>

<!-- Botão p/ filtro -->
@if(!filterController) {
<button title="{{ 'map.filter-label' | translate}}" class="btn btn-success search" (click)="openSidebarEdit()"><mat-icon
    svgIcon="bx-search-white" style="font-size: 0px; margin-top: 5px;"></mat-icon>
</button>
}


<!-- Sidebar de filtro -->

@if(filterController){
<div class="sidebar-edit" [formGroup]="filterForm">

  <mat-icon (click)="closeEditionSideBar()">clear</mat-icon>
  <h2> {{ 'map.filter-label' | translate}} </h2>
  <hr>

  @if(lastQuery != 'is_active=true') {
  <p class="select-filter" (click)="selectLastQuery()">{{
    'map.select-last-filter' | translate }}</p>
  }

  <mat-tab-group mat-stretch-tabs="true" mat-align-tabs="center">
    <!-- filtro por elementos -->
    <mat-tab label="{{ 'map.filter-fields' | translate}}">
      <hr>
      <mat-form-field appearance="outline">
        <mat-label> {{ 'map.reference-label' | translate}} </mat-label>
        <input matInput formControlName="reference">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{'map.serial-number-label' | translate}} </mat-label>
        <input matInput formControlName="serialNumber">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label> {{ 'map.magnetic-key' | translate}} </mat-label>
        <mat-select formControlName="magneticKey">

          <mat-option apperance="outline" [value]="null">
            {{ 'map.none' | translate}}
          </mat-option>

          <mat-option apperance="outline" [value]="true">
            {{ 'map.maybe' | translate}}
          </mat-option>

          <mat-option apperance="outline" [value]="false">
            {{ 'map.it-has-not' | translate}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label> {{ 'map.subdivision' | translate }} </mat-label>
        <mat-select multiple formControlName="division">

          @if(!allDivisions.length) {
          <mat-option disabled>
            {{ 'map.no-subdivision' | translate}}
          </mat-option>
          }

          @for (division of allDivisions; track division.id) {
          <mat-option apperance="outline">
            {{division.reference}}
          </mat-option>
          }

        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label> {{ 'map.gateway' | translate }} </mat-label>
        <mat-select multiple formControlName="gateway" panelClass="gateway-select-panel">
          <mat-form-field [style.width.%]="100" appearance="outline">
            <mat-label>Filtrar</mat-label>
            <input matInput #searchGateways class="input-filter" focused="true"
              (keyup)="filterGateways(searchGateways.value)" (keydown)="$event.stopPropagation()">
          </mat-form-field>

          @if (!allGateways.length) {
          <mat-option disabled>{{ 'map.no-gateway' | translate }}</mat-option>
          }

          @for (gateway of filteredGateways; track gateway.id) {
          <mat-option apperance="outline">{{gateway.reference}}</mat-option>
          }

        </mat-select>
      </mat-form-field>

      <div class="buttons">
        @if(!filterLoading) {
        <button class="btn btn-success filter" (click)="filterByElements()">{{
          'map.filter-label' | translate }}</button>
        <button class="btn btn-secondary filter" (click)="resetGateways()">{{
          'map.reset-label' | translate }}</button>
        }
      </div>

      @if (filterLoading) {
      <div class="spinner">
        <div class="custom-loader"></div>
        @if (markers.length > 0 && totalInstallations > 0) {
        <p>{{ ((markers.length / totalInstallations) *
          100).toFixed(0) }}%</p>
        }

        @if (markers.length === 0 && totalInstallations >= 0) {
        <p>0%</p>
        }
      </div>
      }
    </mat-tab>

    <!-- filtro por formas -->
    <mat-tab label="{{ 'map.area-label' | translate }}">
      <hr>
      <br>
      <mat-slide-toggle class="example-margin" color="accent" [formControl]="polygonSlideToggle"
        (change)="openPolygon()">
        {{ 'map.polygon' | translate }}
      </mat-slide-toggle>
      <br><br>
      <hr>
      <br>
      <div class="addres-label">
        <mat-label>Endereço</mat-label>
      </div>
      <br>
      <mat-form-field appearance="outline">
        <mat-label> {{ 'map.street' | translate }} </mat-label>
        <input matInput formControlName="street">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label> {{ 'map.district' | translate }} </mat-label>
        <input matInput formControlName="district">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label> Latitude </mat-label>
        <input matInput formControlName="latitude">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label> Longitude </mat-label>
        <input matInput formControlName="longitude">
        <mat-hint align="start"><strong>Informe os campos de latitude e longitude
          </strong> </mat-hint>
      </mat-form-field>
      <br>

      @if (!filterFormsLoading) {
      <button class="btn btn-success filter" id="btn-filter" (click)="filterBypolygons()">{{
        'map.filter-label' | translate }} </button>
      }

      @if (filterFormsLoading) {
      <div class="spinner">
        <div class="custom-loader"></div>
        @if (markers.length > 0 && totalInstallations > 0) {
        <p>{{ ((markers.length / totalInstallations) * 100).toFixed(0) }}%</p>
        }

        @if (markers.length === 0 && totalInstallations >= 0) {
        <p>0%</p>
        }
      </div>
      }
    </mat-tab>
  </mat-tab-group>
</div>
}

<!-- Sidebar de mais informações -->
@if (moreInfoController) {
<div class="sidebar-edit">
  <mat-icon (click)="closeMoreInformation()">clear</mat-icon>

  <mat-button-toggle-group [(ngModel)]="choiceOptionsToView">
    <!-- Detalhes -->
    <mat-button-toggle value="details">{{ 'map.details-label' | translate }}</mat-button-toggle>
  </mat-button-toggle-group>

  @if(choiceOptionsToView === 'details') {
  <div class="details">
    <div class="table">
      <table>
        <tbody>
          <tr>
            <td><strong>{{ 'map.serial-number-label' | translate }}</strong></td>
            <td>{{ serialNumber }}
              @if(detailConsuptionLoading) {
              <mat-spinner [diameter]="20"></mat-spinner>
              }
            </td>
          </tr>
          <tr>
            <td><strong>{{ 'map.address-label' | translate }}</strong></td>
            <td>{{ address }}
              @if(detailConsuptionLoading){
              <mat-spinner [diameter]="20"></mat-spinner>
              }
            </td>
          </tr>
          <tr>
            <td><strong>{{ 'map.gateway-label' | translate }}</strong></td>
            <td>{{ gateway }}</td>
          </tr>
          <tr>
            <td><strong>{{ 'map.lat-label' | translate }}</strong></td>
            <td>{{ lat }}</td>
          </tr>
          <tr>
            <td><strong>{{ 'map.long-label' | translate }}</strong></td>
            <td>{{ long }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  }

  <!-- Sidebar de mais informações -->
  @if(demonstrationController && !isRunning) {

  <div class="sidebar-edit sidebar-demonstration">
    <mat-icon (click)="closeDemonstrationMode()">clear</mat-icon>
    <h2>{{ 'map.demonstration-mode' | translate }}</h2>
    <br>
    <mat-form-field appearance="outline" [formGroup]="demonstrationForm">
      <mat-label> {{ 'map.filter-delay' | translate }} <strong>[Min 5]</strong></mat-label>
      <input type="number" matInput min="5" formControlName="delay">
    </mat-form-field>

    <div class="buttons">
      @if(!isRunning){
      <button class="btn btn-success filter" [disabled]="!demonstrationForm.valid" (click)="startDemonstration()"> {{
        'map.start-demonstration' | translate }}
      </button>
      }
    </div>
  </div>
  }

  @if (demonstrationController && isRunning) {
  <div class="sidebar-running">
    <mat-icon (click)="closeDemonstrationMode()">clear</mat-icon>
    <div class="gateway-info">
      <label>{{ 'map.gateway-reference' | translate }}</label>
      <h2>{{ gatewayName }}</h2>
    </div>

    @if(elementIsFound){
    <div class="table">
      <table>
        <tbody>
          <tr>
            <td><strong>{{ 'map.serial-number-label' | translate }}</strong></td>
            <td>{{ selectedGateway.serialNumber }}</td>
          </tr>
          <tr>
            <td><strong>{{ 'map.cpu-usage' | translate }}</strong></td>
            <td>{{ selectedGateway.cpuPercent }}%</td>
          </tr>
          <tr>
            <td><strong>{{ 'map.current-temperature' | translate }}</strong></td>
            <td>{{ selectedGateway.temperatureCurrent }}Cº</td>
          </tr>
          <tr>
            <td><strong>{{ 'map.last-reboot' | translate }}</strong></td>
            <td>{{ selectedGateway.lastReboot }}</td>
          </tr>
          <tr>
            <td><strong>{{ 'map.disk-usage' | translate }}</strong></td>
            <td>{{ selectedGateway.diskPercent }}%</td>
          </tr>
          <tr>
            <td><strong>{{ 'map.equipment-count' | translate }}</strong></td>
            <td><label>{{ equipmentCount }}</label>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    }

    @if(isRunning){
    <button class="btn btn-secondary" (click)="stopDemonstration()"> {{
      'map.stop-demonstration' | translate }}
    </button>
    }
  </div>
  }
</div>
}